export const paidOut = {
  all: "all",
  onlyPaidOut: true,
  onlyNotPaidOut: false,
};

export const exported = {
  all: "all",
  onlyExported: true,
  onlyNotExported: false,
};

export const fullyPaid = {
  all: "all",
  onlyFullyPaid: true,
  onlyNotFullyPaid: false,
};
